import {extractDataFromResponse} from "../../saga-utils/httpInterceptorWrapper";
import {call} from "redux-saga-test-plan/matchers";
import {getArtistDetailData} from "../../../api/artistApi";
import {LOAD_ARTIST_BASE_DATA, loadArtistBaseDataSuccessAction} from "../artistActions";
import {emitNotificationAction} from "../../notification/notificationAction";
import {createErrorNotification} from "../../../models/notification";
import i18next from "i18next";
import {pushHistory} from "../../router/routerActions";
import {put, takeLatest} from "redux-saga/effects";
import {i18_ARTIST} from "../../../i18nReferences";

function* processLoadArtistBaseData({payload}) {
    try {
        const artistId = payload.artistId
        const artistData = extractDataFromResponse(yield call(getArtistDetailData, {
            artistId,
            segments: 'base'
        }))
        yield put(loadArtistBaseDataSuccessAction(artistData))

    } catch (err) {
        yield put(emitNotificationAction(createErrorNotification(i18next.t('EDIT_ARTIST.LOAD_DATA_FAILED_INFO', {ns: i18_ARTIST}), 'loadArtistData')))
        yield put(pushHistory('/'))
        console.log(err)
    }
}

export function* watchLoadArtistBaseData() {
    yield takeLatest(LOAD_ARTIST_BASE_DATA, processLoadArtistBaseData)
}
